import React from 'react';
import { useSelector } from 'react-redux';
import { THEME } from '../../utils/theme';

const OrderSummaryStep = () => {
  const { selectedDate, mealType, plateSize, numberOfPlates, name, phone, email, address } = useSelector(state => state.orderForm);
  
  // Styles object
  const styles = {
    sectionContainer: {
      marginBottom: '25px'
    },
    sectionTitle: {
      marginTop: 0,
      marginBottom: '15px',
      color: THEME.text.primary,
      fontSize: '16px',
      fontWeight: '600',
      borderBottom: `2px solid ${THEME.border.light}`,
      paddingBottom: '10px'
    },
    addressLabelDiv: {
      display: 'block',
      marginBottom: '8px',
      fontWeight: '600',
      color: THEME.text.secondary,
      fontSize: '13px'
    },
    addressValueDiv: {
      wordBreak: 'break-word',
      lineHeight: '1.5',
      color: THEME.text.primary
    },
    discountMessage: {
      padding: '10px 12px',
      backgroundColor: THEME.warning.light,
      borderLeft: `4px solid ${THEME.warning.main}`,
      borderRadius: '4px',
      fontSize: '13px',
      color: THEME.warning.dark,
      marginTop: '15px'
    }
  };
  
  return (
    <>
      {/* Single Consolidated Order Card */}
      <div className='order-summary-card'>
        {/* Order Details Section */}
        <div style={styles.sectionContainer}>
          <h3 style={styles.sectionTitle}>📋 Order Details</h3>
          <div className='summary-item'>
            <span className='label'>Delivery Date:</span>
            <span className='value'>{new Date(selectedDate).toLocaleDateString('en-IN', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' })}</span>
          </div>
          <div className='summary-item'>
            <span className='label'>Meal Type:</span>
            <span className='value'>{mealType ? mealType.charAt(0).toUpperCase() + mealType.slice(1) : 'N/A'}</span>
          </div>
          {/* <div className='summary-item'>
            <span className='label'>Plate Size:</span>
            <span className='value'>{plateSize === 'full' ? 'Full Plate' : 'Buffet'}</span>
          </div> */}
          <div className='summary-item'>
            <span className='label'>Quantity:</span>
            <span className='value'>{numberOfPlates} {numberOfPlates === 1 ? 'plate' : 'plates'}</span>
          </div>
        </div>

        {/* Customer Details Section */}
        <div style={styles.sectionContainer}>
          <h3 style={styles.sectionTitle}>👤 Customer Details</h3>
          <div className='summary-item'>
            <span className='label'>Name:</span>
            <span className='value'>{name}</span>
          </div>
          <div className='summary-item'>
            <span className='label'>Phone:</span>
            <span className='value'>{phone}</span>
          </div>
          <div className='summary-item'>
            <span className='label'>Email:</span>
            <span className='value'>{email || 'Not provided'}</span>
          </div>
        </div>

        {/* Delivery Details Section with Spacing */}
        <div style={styles.sectionContainer}>
          <h3 style={styles.sectionTitle}>📍 Delivery Details</h3>
          <div style={{ marginBottom: '20px' }}>
            <div className='label' style={styles.addressLabelDiv}>Address:</div>
            <div className='value' style={styles.addressValueDiv}>{address}</div>
          </div>
        </div>

        {/* Discount Messages */}
        {/* {plateSize === 'half' && numberOfPlates > 5 && (
          <div style={styles.discountMessage}>
            ✓ Free delivery on orders above 5 plates!
          </div>
        )}
        {plateSize === 'full' && numberOfPlates > 6 && (
          <div style={styles.discountMessage}>
            ✓ Special price of ₹60 per plate!
          </div>
        )}
        {plateSize === 'full' && numberOfPlates > 15 && (
          <div style={styles.discountMessage}>
            ✓ Bulk discount! Price reduced to ₹55 per plate!
          </div>
        )} */}
      </div>
    </>
  );
};

export default OrderSummaryStep;
